import React from "react"
import { Flex, theme, Typography } from "antd"

interface AvailableBalanceProps {
  balance?: string
  currency?: string
}
export const ConvertFormAvailableBalance = ({
  balance,
}: AvailableBalanceProps) =>
  balance ? (
    <Flex gap={16} style={{ marginTop: 8 }}>
      <Typography.Text strong>Available balance</Typography.Text>

      <Typography.Text style={{ color: theme.useToken().token.colorPrimary }}>
        {balance}
      </Typography.Text>
    </Flex>
  ) : null
